import { Component } from "react";

import TextField from "@material-ui/core/TextField";

import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";

import CreditDataTable from "./SellTable";

import { numberWithSpaces } from "../../../utilities/formaters";
import PropTypes from "prop-types";

export default class SellOrder extends Component {
  constructor(props) {
    super(props);

    this.state = { depotId: "", fee: 0 };
  }

  render() {
    let mainInfoStyle = { padding: "8px 4px 4px 16px" };
    let header = <h4>Sell Share</h4>;

    if (!this.props.depot.fetched) {
      return (
        <div>
          {header}
          <CircularProgress />
        </div>
      );
    }

    if (!this.props.depot.data[this.props.accountId]) {
      return (
        <div>
          {header}
          <p>No depods found</p>
        </div>
      );
    }

    return (
      <div style={{ marginTop: "50px" }}>
        {header}
        <div style={mainInfoStyle}>
          <div>
            <TextField
              size="small"
              variant="outlined"
              select
              label={"Choose Depot"}
              value={this.state.depotId}
              style={{ marginRight: "10px", width: "250px" }}
              onChange={this.handleSelectDepotChange}
            >
              {this.buildDepotItems()}
            </TextField>

            <TextField
              size="small"
              variant="outlined"
              value={this.state.fee}
              onChange={this.updateFee}
              label="Fee % (max 2%)"
              style={{
                marginRight: "10px",
                width: "50px",
                marginBottom: "3px",
                verticalAlign: "bottom",
              }}
            />
          </div>

          {this.buildCreditItems()}
        </div>
      </div>
    );
  }

  sendSellOrder = (fee, creditId, depotId) => {
    let percentage = Math.floor(parseFloat(fee) * 100);
    this.props.palceSellOrder(creditId, depotId, percentage);
    this.setState({ submitted: true });
  };

  updateFee = (event) => {
    let percantage = event.target.value;
    percantage = percantage.toString().replace(",", ".");
    //console.log(percantage);
    if (isNaN(percantage)) {
      return;
    }

    if (Number(percantage) >= 2) percantage = "2";

    // cut down the number of decimal places to 2
    if (percantage.indexOf(".") >= 0) {
      let array = percantage.split(".");
      let decimals = array[1];
      if (decimals.length == 1) decimals = decimals.substring(0, 1);
      if (decimals.length >= 2) decimals = decimals.substring(0, 2);
      percantage = array[0] + "." + decimals;
    }

    this.setState({ fee: percantage });
  };

  handleSelectDepotChange = (event) => {
    this.setState({ depotId: event.target.value });

    // eslint-disable-next-line no-undef
    let holding = this.props.depot.holdings[value];
    holding = holding ? holding : {};
    if (!holding.fetching && !holding.error) {
      // eslint-disable-next-line no-undef
      this.props.getHoldignsForDepot(value);
    }
  };

  buildDepotItems = () => {
    var depotData = this.props.depot.data[this.props.accountId];

    return depotData.map((item) => {
      let Name = item.Name ? item.Name : "Primary";
      return (
        <MenuItem key={item.Id} value={item.Id}>
          {Name + " - Value: " + numberWithSpaces(item.Balance.Amount)}
        </MenuItem>
      );
    });
  };

  buildCreditItems = () => {
    if (!this.state.depotId) return [];

    var holdings = this.props.depot.holdings[this.state.depotId];
    holdings = holdings ? holdings : {};

    if (holdings.fetching) return [];
    if (holdings.error)
      return [
        <MenuItem key={"--"} value={"-"}>
          error loading data
        </MenuItem>,
      ];
    if (holdings.data.length == 0)
      return [
        <MenuItem key={"--"} value={"-"}>
          no credits on this depot
        </MenuItem>,
      ];

    return (
      <CreditDataTable
        {...this.props}
        {...this.state}
        dataRow={holdings.data}
        sendSellOrder={this.sendSellOrder}
      />
    );
  };

  static propTypes = {
    depot: PropTypes.object,
    currentUser: PropTypes.object,
    accountId: PropTypes.string,
    palceSellOrder: PropTypes.func,
    getHoldignsForDepot: PropTypes.func,
  };
}
